import { render, staticRenderFns } from "./preview_modal_home_3_call_button.vue?vue&type=template&id=0afca0a1&scoped=true"
import script from "./preview_modal_home_3_call_button.vue?vue&type=script&lang=js"
export * from "./preview_modal_home_3_call_button.vue?vue&type=script&lang=js"
import style0 from "./preview_modal_home_3_call_button.vue?vue&type=style&index=0&id=0afca0a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afca0a1",
  null
  
)

export default component.exports